import {List} from 'immutable';

import {createSelector} from '@store/@common';

import {UserId} from 'records/User';
import CoachingPlanStore from 'stores/coaching/CoachingPlanStore';
import {getNumberQueryParam} from 'utils/getQueryParam';

const baseCoachingPlan = createSelector(CoachingPlanStore);

export const coachingPlan = createSelector([baseCoachingPlan], planStore => {
  // TODO: window.location must be wrapped to store-selectors functionality to update selectors each time it changed
  const planId = getNumberQueryParam(window.location, 'planId');
  if (!planId) {
    return null;
  }
  return planStore.planMap.get(planId);
});

export const coachingPlansInMap = createSelector(
  [baseCoachingPlan],
  planStore => planStore.planMap
);

export const getRepHasPlan = createSelector([coachingPlansInMap], planMap => (repId: UserId) => {
  return !!planMap.find(cp => cp.recipient.id === repId && !cp.completed);
});

export const getCoachingRepsByManagerId = createSelector(
  [coachingPlansInMap],
  plans => (managerId: string) => {
    if (managerId) {
      return plans
        .filter(el => el.coach.id === managerId && !el.completed)
        .map(el => el.recipient.id)
        .filter(Boolean)
        .toArray();
    }

    return List();
  }
);
